import {VStore} from "../../store";
import {AUSWHAL, BALKON, FULLUNG, MONTAGEART, WANDABSTAND} from "../../data";
import './_v-controller.scss';
import VOption from "./v-option/v-option.tsx";
import VRange from "./v-range/v-range.tsx";


export default function VController() {
    const {
        width,
        setWidth,
        depth,
        setDepth,
        auswahl,
        setAuswahl,
        balkon,
        setBalkon,
        montageart,
        setMontageart,
        wandabstand,
        setWandabstand,
        fullung,
        setFullung
    } = VStore();

    return (<div className="v-controller">
        <VOption
            title="Auswahl Geländertyp"
            options={AUSWHAL}
            value={auswahl}
            onChange={setAuswahl}
        />
        <VOption
            title="Balkon Form"
            options={BALKON}
            value={balkon}
            onChange={setBalkon}
        />
        <VOption
            title="Füllung"
            options={FULLUNG}
            value={fullung}
            onChange={setFullung}
        />
        <VOption
            title="Montageart"
            options={MONTAGEART}
            value={montageart}
            onChange={setMontageart}
        />
        {
            montageart === 'vorgesetzt' && (
                <VOption
                    title="Wandabstand"
                    options={WANDABSTAND}
                    value={wandabstand}
                    onChange={setWandabstand}
                />
            )
        }
        <VRange
            title="Depth"
            value={depth}
            min={1.25}
            max={4}
            step={0.01}
            onChange={setDepth}
        />
        <VRange
            title="Width"
            value={width}
            min={2.4}
            max={4}
            step={0.01}
            onChange={setWidth}
        />
    </div>);
}
